// extracted by mini-css-extract-plugin
module.exports = {"anchor":"styles_anchor__Sd07B","image":"styles_image__1pLH-","zoom":"styles_zoom__3Rrmb"};